/*
 * Calendar Filter Panel component
 * Provides filter panel interface and calls external filter application function
 *
 * Angular module: trackerbase-app.views.tracking-calendar-view.calendar-filter-panel
 * Component Name: tbCalendarFilterPanel (or tb-calendar-filter-panel)
 */

import angular from "angular";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

import CalendarFilterPanelController from "./CalendarFilterPanelController";

const CalendarFilterPanelComponent = {
    name: "tbCalendarFilterPanel",
    config: {
        template: CalendarFilterPanelController.template,
        controller: CalendarFilterPanelController,
        controllerAs: CalendarFilterPanelController.controllerAs,
        bindings: {
            applyCalendarFilterFn: "&tbApplyCalendarFilterFn",
            additionalPanelClasses: "@tbAdditionalPanelClasses",
            filterPanelInitialized: "=tbFilterPanelInitialized",
            displayFilterPanel: "=tbDisplayFilterPanel"
        }
    }
};

const calendarFilterPanelComponentDependencies = DependencyListBuilder([
    CalendarFilterPanelController.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-calendar-view.calendar-filter-panel",
        calendarFilterPanelComponentDependencies
    )
    .component(CalendarFilterPanelComponent.name, CalendarFilterPanelComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/CalendarFilterPanel.js
// module id = nPwb
// module chunks = 1